import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { P, APPLICATION_FINDER_URL } from 'shared';
import { ContactInfo } from '../components';
import { APPLICATION_STATUS_MESSAGES } from '../constants/applicationStatusMessages';
import { selectors } from '../reducer';
/*
  This page is shown when the user is hard declined by Bread.
*/
function DeclinedPage() {
    const history = useHistory();
    const prequalification = useSelector(selectors.prequalification);
    if (!prequalification) {
        history.push(APPLICATION_FINDER_URL);
        return null;
    }
    return (_jsx("div", { className: "declined-container", children: _jsx(DeclinedResponse, {}) }));
}
const DeclinedResponse = ({ withBoxShadow = false, }) => {
    return (_jsxs("div", { className: classNames({
            'w100 pad-20 border-none': true,
            'box-shadow-glow': withBoxShadow,
        }), children: [_jsx(P, { children: APPLICATION_STATUS_MESSAGES.DECLINED.subtitle }), _jsx(P, { className: "mar-t-20", children: APPLICATION_STATUS_MESSAGES.DECLINED.message }), _jsx(ContactInfo, {})] }));
};
export default DeclinedPage;
